import notificationActionTypes from './notificationActionTypes';
import {
    NotificationState,
    NotificationReducerAction,
} from './notificationRedux.types';

export const initialNotificationState: NotificationState = {
    message: '',
    variant: 'info',
    show: false,
    sx: null,
    autoHideDuration: 6000,
    autoHide: true,
};

const notificationReducer = (
    state = initialNotificationState,
    action: NotificationReducerAction,
): NotificationState => {
    switch (action.type) {
        case notificationActionTypes.SHOW_NOTIFICATION:
            return {
                ...initialNotificationState,
                ...action.payload,
                show: true,
            };
        case notificationActionTypes.CLOSE_NOTIFICATION:
            return {
                ...state,
                show: false,
            };
        default:
            return state;
    }
};

export default notificationReducer;
